import { call, put, takeLatest } from "redux-saga/effects"
import * as gql from "../../../common/graphql"
import {
  AUTH_FETCH_USERINFO_BEGIN,
  AUTH_FETCH_USERINFO_DISMISS_ERROR,
  AUTH_FETCH_USERINFO_FAILURE,
  AUTH_FETCH_USERINFO_SUCCESS,
} from "./constants"
import { DEFAULT_LANGUAGE } from "../../../i18next"

const LOCALE_ENUM = Object.freeze({
  DE: "de",
  FR: "fr",
  IT: "it",
})

export function fetchUserinfo(authToken) {
  return {
    type: AUTH_FETCH_USERINFO_BEGIN,
    data: { authToken },
  }
}

export function dismissFetchUserinfoError() {
  return {
    type: AUTH_FETCH_USERINFO_DISMISS_ERROR,
  }
}

// worker Saga: will be fired on AUTH_FETCH_USERINFO_BEGIN actions
export function* doFetchUserinfo({ data: { authToken } }) {
  const { data, graphqlErrors, networkError } = yield call(gqlFetchUserinfo, authToken)

  if (data) {
    const locale = data.authenticatedUser && data.authenticatedUser.locale
    const lang = LOCALE_ENUM[locale] || DEFAULT_LANGUAGE

    yield put({
      type: AUTH_FETCH_USERINFO_SUCCESS,
      data: { lang },
    })
  } else {
    yield put({
      type: AUTH_FETCH_USERINFO_FAILURE,
      data: { error: { graphqlErrors, networkError } },
    })
  }
}

export function gqlFetchUserinfo(authToken) {
  return gql.post({
    authToken,
    queryName: "fetchUserinfo",
    query: `query fetchUserinfo {
      authenticatedUser {
        locale
      }
    }`,
  })
}

/*
  Alternatively you may use takeEvery.

  takeLatest does not allow concurrent requests. If an action gets
  dispatched while another is already pending, that pending one is cancelled
  and only the latest one will be run.
*/
export function* watchFetchUserinfo() {
  yield takeLatest(AUTH_FETCH_USERINFO_BEGIN, doFetchUserinfo)
}

// Redux reducer
export function reducer(state, action) {
  switch (action.type) {
    case AUTH_FETCH_USERINFO_BEGIN:
      return {
        ...state,
        fetchUserinfoPending: true,
        fetchUserinfoError: null,
      }

    case AUTH_FETCH_USERINFO_SUCCESS:
      return {
        ...state,
        ...action.data,
        fetchUserinfoPending: false,
        fetchUserinfoError: null,
      }

    case AUTH_FETCH_USERINFO_FAILURE:
      return {
        ...state,
        fetchUserinfoPending: false,
        fetchUserinfoError: action.data.error,
      }

    case AUTH_FETCH_USERINFO_DISMISS_ERROR:
      return {
        ...state,
        fetchUserinfoError: null,
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/features/auth/redux/fetchUserinfo.js